import helperapi from "./helper";

/**
 * Mutabakat formu oluşturma isteği.
 * PDF dosyalarını multipart/form-data olarak Helper API'ye gönderir.
 *
 * Endpoint: POST Agreements/create-form
 *
 * @param {{ zipFileName: string, files: File[] }} params
 * @returns {Promise<{ items: Array, bytes: string, fileName: string, contentType: string }>}
 */
export async function createMutabakat({ zipFileName, files }) {
    const formData = new FormData();
    formData.append("ZipFileName", zipFileName);
    files.forEach((file) => formData.append("Files", file));

    const { data } = await helperapi.post("/Agreements/create-form", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });

    // API camelCase veya PascalCase dönebilir — her ikisini de destekle
    return {
        items: (data.items ?? data.Items ?? []).map((item) => ({
            companyName: item.companyName ?? item.CompanyName ?? "",
            date: item.date ?? item.Date ?? "",
            amount: item.amount ?? item.Amount ?? 0,
        })),
        bytes: data.bytes ?? data.Bytes ?? null,
        fileName: data.fileName ?? data.FileName ?? null,
        contentType: data.contentType ?? data.ContentType ?? null,
    };
}

/**
 * Base64 kodlanmış dosyayı tarayıcıda indirtir.
 *
 * @param {string} base64 - Base64 string
 * @param {string} fileName - İndirilecek dosya adı
 * @param {string} contentType - MIME tipi (ör. "application/zip")
 */
export function downloadFromBase64(base64, fileName, contentType) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
